import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Operation} from "../../../models/auth.model";
import {LoadingController, ModalController} from "@ionic/angular";
import {AuthService} from "../../../services/auth.service";
import {Router} from "@angular/router";
import {ApiService} from "../../../services/api.service";

@Component({
  selector: 'app-form-complete',
  templateUrl: './form-complete.component.html',
  styleUrls: ['./form-complete.component.scss'],
})
export class FormCompleteComponent implements OnInit {
  private loading: any;
  @Input() operation: Operation = Operation.Register;
  @Input() password: any;
  @Input() firstName: any;
  @Input() lastName: any;
  @Input() phone: any;
  form: FormGroup | undefined;
  isSend = false;
  resp: any;

  constructor(
    private modalCtrl: ModalController,
    private loadingCtrl: LoadingController,
    private router: Router,
    private auth: AuthService,
    private api: ApiService
  ) { }

  async ngOnInit() {
    this.loading = await this.loadingCtrl.create({
      message: 'Loading...',
      spinner: 'circles',
    });
    this.form = new FormGroup({
      code: new FormControl(null, [Validators.required])
    });
  }
  
  modalDismiss() {
    this.modalCtrl.dismiss();
  }

  async send() {
    this.form?.markAllAsTouched();
    if (this.form?.invalid) { return; }
    this.loading.present().then();
    this.isSend = true;
    if (this.operation === Operation.Register) {
      this.auth.registerComplete({
        code: this.form?.get('code')?.value,
        token: this.auth.token,
        password: this.password,
        firstName: this.firstName,
        lastName: this.lastName
      }).subscribe(async resp => {
        if (this.auth.isAuthenticated) {
          this.loading.dismiss().then();
          this.modalCtrl.dismiss().then();
          this.modalCtrl.dismiss(null, undefined, 'FormRegistration').then();
          this.auth.isAuthenticated$.next(true);
          this.router.navigateByUrl(`/${this.auth.defaultPage}`, { state: {edit: true} }).then();
          return;
        }
        this.resp = resp;
        this.loading.dismiss().then();
        this.isSend = false;
      }, resp => {
        console.error(resp);
      });
    } else if (this.operation === Operation.ByPhone) {
      this.auth.byPhoneComplete({
        code: this.form?.get('code')?.value,
        token: this.auth.token
      }).subscribe(async resp => {
        if (this.auth.isAuthenticated) {
          this.loading.dismiss().then();
          this.modalCtrl.dismiss().then();
          this.modalCtrl.dismiss(null, undefined, 'FormLogin').then();
          this.auth.isAuthenticated$.next(true);
          this.router.navigateByUrl(`/${this.auth.defaultPage}`, { state: {edit: true} }).then();
          return;
        }
        this.resp = resp;
        this.loading.dismiss().then();
        this.isSend = false;
      }, resp => {
        console.error(resp);
      });
    } else if (this.operation === Operation.ProfileConfirmPhone) {
      this.api.profile.phoneConfirm(this.form?.get('code')?.value).then(resp => {
        this.resp = resp;
        this.loading.dismiss().then();
        this.isSend = false;
        if (!this.resp?.messages?.length) {
          this.modalCtrl.dismiss(this.resp, 'confirm').then();
        }
      })
    }
  }
}
